import React from 'react';
import { motion } from 'framer-motion';
import { Search, Sliders, HeartHandshake } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const steps = [{
  icon: Search,
  number: '01',
  title: 'Antes de tocarte, te evalúa.',
  description: "Analiza tu tipo de piel, tu historia, tus hábitos, tus preocupaciones específicas. Construye un mapa de lo que tu piel necesita — no de lo que funciona 'en general.'"
}, {
  icon: Sliders,
  number: '02',
  title: 'Luego diseña tu protocolo.',
  description: 'Combinando técnicas avanzadas de cuidado coreano con tecnología de última generación disponible en su spa, Kate selecciona el tratamiento exacto para tu condición. No más. No menos.'
}, {
  icon: HeartHandshake,
  number: '03',
  title: 'Y te acompaña en el proceso.',
  description: 'No te vende una sesión y desaparece. Te guía. Te educa. Te enseña a entender tu propia piel para que los resultados duren mucho más allá de la sala de tratamiento.'
}];
export function ProtocolSection() {
  const {
    t
  } = useLanguage();
  const steps = [{
    icon: Search,
    number: '01',
    title: t('protocol.s1_title'),
    description: t('protocol.s1_desc')
  }, {
    icon: Sliders,
    number: '02',
    title: t('protocol.s2_title'),
    description: t('protocol.s2_desc')
  }, {
    icon: HeartHandshake,
    number: '03',
    title: t('protocol.s3_title'),
    description: t('protocol.s3_desc')
  }];
  return <section id="protocolo" className="py-12 md:py-24 bg-brand-cream relative" data-id="element-303">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16" data-id="element-305">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-306">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-307">
              {t('protocol.title')}
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full mb-8" data-id="element-308"></div>
            <p className="text-lg text-brand-charcoal mb-4" data-id="element-309">
              {t('protocol.p1')}
            </p>
            <p className="text-xl font-medium text-brand-brown" data-id="element-310">
              {t('protocol.p2')}
            </p>
            <p className="text-lg text-brand-charcoal mt-4" data-id="element-311">
              {t('protocol.p3')}
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-312">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-313">
              <div className="absolute -right-4 -top-4 text-9xl font-serif font-bold text-brand-cream opacity-50 group-hover:scale-110 transition-transform duration-500" data-id="element-314">
                {step.number}
              </div>

              <div className="relative z-10" data-id="element-315">
                <div className="w-14 h-14 bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-316">
                  <step.icon className="w-7 h-7" data-id="element-317" />
                </div>
                <h3 className="text-xl font-serif text-brand-brown mb-4 font-bold" data-id="element-318">
                  {step.title}
                </h3>
                <p className="text-brand-charcoal leading-relaxed" data-id="element-319">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}